import React from 'react';
import { useDispatch } from 'react-redux';

import { ResponsiveDialog, useQuery, useSettings, useUserData, Utils } from 'app/main/components';
import AddRowsQueryDialog from 'app/main/modules/components/AddRowsQueryDialog';
import AddRowsResultDialog from 'app/main/modules/components/AddRowsResultDialog';
import CompaniesListItem from 'app/main/modules/companies/CompaniesListItem';
import PeopleListItem from 'app/main/modules/people/PeopleListItem';

interface CommercialCampaignsRowsAddQueryDialogProps {
	openDialog: boolean;
	switchOpenDialog: VoidFunction;
	table: string;
	cmcpUid: string;
	updateRefresh: VoidFunction;
}

const defaultFilters = [
	{ filt_field: 'comp_deleted', filt_clause: 'not_equal', filt_value: 1 },
	{ filt_field: 'peop_deleted', filt_clause: 'not_equal', filt_value: 1 }
];

export default function CommercialCampaignsRowsAddQueryDialog(props: CommercialCampaignsRowsAddQueryDialogProps) {
	const dispatch = useDispatch();
	const { t } = useSettings();
	const userData = useUserData();

	const { query, currentTree, queryConfig, handleQueryChange, handleQueryApply, handleQueryClear } = useQuery({
		module: props.table
	});

	const [showResultsDialog, setShowResultsDialog] = React.useState(false);

	const closeDialog = () => {
		handleQueryClear();
		setShowResultsDialog(false);
		props.switchOpenDialog();
	};

	const showResults = () => {
		handleQueryApply();
		setShowResultsDialog(true);
	};

	const addRows = () => {
		Utils.executeStored({
			action: 'st_commercialcampaigns_rows_add_multiple',
			dispatch,
			data: {
				cmrw_cmcp_uid: props.cmcpUid,
				cmrw_user_created_uid: userData.user_uid,
				cmrw_table: props.table,
				filters: [
					...defaultFilters,
					{
						filt_field: 'cmrw_table',
						filt_clause: 'equals',
						filt_value: props.table
					}
				],
				query
			},
			successHandler: () => {
				dispatch(Utils.alertSuccessMsg(t));
				closeDialog();
				props.updateRefresh();
			}
		});
	};

	return (
		<ResponsiveDialog open={props.openDialog} onClose={props.switchOpenDialog} maxWidth="lg">
			{!showResultsDialog ? (
				<AddRowsQueryDialog
					title={t(`COMMERCIALCAMPAIGNS_SECTION_ADD_${props.table}_TITLE`)}
					currentTree={currentTree}
					queryConfig={queryConfig}
					handleQueryChange={handleQueryChange}
					showResults={showResults}
					closeDialog={closeDialog}
				/>
			) : (
				<AddRowsResultDialog
					title={t('COMMERCIALCAMPAIGNS_DIALOG_TITLE_ADD_RESULT')}
					module={props.table}
					itemLayout={props.table === 'companies' ? CompaniesListItem : PeopleListItem}
					defaultFilters={[
						...defaultFilters,
						{
							filt_field: 'cmrw_table',
							filt_clause: 'equals',
							filt_value: props.table
						}
					]}
					defaultQuery={query}
					addRows={addRows}
					goBack={() => setShowResultsDialog(false)}
				/>
			)}
		</ResponsiveDialog>
	);
}
